(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('store-categorys', {
                parent: 'admin',
                url: '/store-categorys',
                data: {
                    authorities: ['STORE_READ'],
                    pageTitle: 'categorys.store.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/category/categorys-table.html',
                        controller: 'StoreCategorysController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('categorys');
                        return $translate.refresh();
                    }]

                }
            })
    }
})();
